import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { showLoader } from "./../../redux/actions/action_loader";
import { Field, reduxForm } from "redux-form";
import { getApiData } from "../../api/api";
import createInput from "./../../utils/createInputs";
import "./CustomerFeedback.css";
import { isDateYearValid } from "../../utils/dateYear";
import Fab from "@material-ui/core/Fab";
import ChevronLeftTwoToneIcon from "@material-ui/icons/ChevronLeftTwoTone";
import ChevronRightTwoToneIcon from "@material-ui/icons/ChevronRightTwoTone";
import { mapKeys, values } from "lodash";
import {
  handleQuestionsDisplay,
  makeBrAddedFalse,
} from "./../../utils/handelQuestionsDisplay";
import { healthArray } from "./../../utils/healthArray";
import { withTranslation } from "react-i18next";
import HeadStepper from "../HeadStepper/HeadStepper";
import {
  hybridPosvSteps,
  isNpsSteps,
  photoVerificationSteps,
  QCSteps,
} from "../../utils/stepperStep";
import AxiosRequest from "../../utils/axios";
import {
  muteAudio,
  playVoiceOver,
  stopAudio,
} from "../../utils/handleVoiceAndLang";
import { compress, getBase64TypeAndString } from "../../utils/compressor";
import {
  handleProgress,
  isNewUI,
  isPODPosv,
  isSeniorCitizen,
  redirectToVerify,
} from "../../utils/handleProgress";
import { alertIcon } from "../../images/images";
import DotsLoader from "../Loader/DotsLoader/DotsLoader";
import "./CustomerFeedbackUI.css";
import {
  insurerProposerQuesResponse,
  questionResponseData,
  sspQuesResponse,
} from "../../utils/staticQuestionDataForNewScreen";
import PlanCodeDrawer from "../POSV_New_Ui/PlanCodeDrawer/PlanCodeDrawer";
import { SpeakerContext } from "../../context/SpeakerContext";
import VideoSubmission from "../POSV_New_Ui/VideoSubmission/VideoSubmission";
import {
  irpDeclaration,
  psmDeclaration,
  psmIrpDeclaration,
} from "../../utils/disclaimerText";
import { id } from "date-fns/locale";
import { Button } from 'unified-ui-components-library'

const axios = new AxiosRequest().getClient();

class CustomerFeedback extends Component {
  state = {
    questions: [],
    parents: [],
    primaries: [],
    secondaries: [],
    secondaries2: [],
    tertiaries: [],
    qstCatName: "",
    qstCatNameNext: "",
    qstCatNamePrevious: "",
    errorMsg: "",
    mandatoryError: "Please answer all the mandatory questions (marked with *)",
    loading: false,
    disableButtons: false,
    disableSimplifiedSubmit: false,
    display: "none",
    dates: [],
    isWopRider: "N",
    primaryUserType: "Proposer",
    secondaryUserType: "Insurer",
    termPlan: undefined,
    heading: "",
    translatedHeading: "",
    isNps: localStorage.getItem("isNps"),
    isVideoPosv: localStorage.getItem("isVideoPosv"),
    simplifiedJourney: localStorage.getItem("simplifiedJourney"),
    journeyBy: localStorage.getItem("journeyBy"),
    twoStep: localStorage.getItem("twoStep"),
    isBlockedJourney: false,
    newCheckbox: isNewUI() ? false : true,
    showPlanCodeDrawer: false,
    redirectRoute: "",
    showRedirectionScreen: false,
    channel: localStorage.getItem("channel"),
    proposalDeclarations: [],
  };

  setButtonAttribute = (value) => {
    const buttons = document.querySelectorAll(".cust_fab");
    buttons.forEach((button) => {
      if (!value) {
        button.removeAttribute("disabled");
        if (!this.state.qstCatNamePrevious) {
          buttons[0].setAttribute("disabled", "");
        }
        return;
      }
      button.setAttribute("disabled", "");
    });
  };

  showMessageInScackbar = ({ showSnackbar, snackbarMsgType, snackbarMsg }) => {
    this.setState({ showSnackbar, snackbarMsgType, snackbarMsg });
  };

  getQstCategory = () => {
    const { simplifiedJourney } = this.state;
    if (simplifiedJourney == "y") {
      return localStorage.getItem("path")
        ? localStorage.getItem("path")
        : localStorage.getItem("category");
    } else {
      return this.props.location.search.split("=")[1];
    }
  };

  componentDidMount() {
    const { handleAudioIconDisplay } = this.context;
    handleAudioIconDisplay(true);
    const selecLang = localStorage.getItem("LanguageSelected");
    if (!selecLang) {
      redirectToVerify(this.props.history);
    }

    document.addEventListener("emitted", (event) => this.onUserAnswer(event));
    const qstCatName = this.getQstCategory();
    if (!qstCatName) {
      this.props.history.push("/vu");
      return;
    }
    // handleProgress(70)
    handleProgress(25); // for new flow
    localStorage.setItem("qstCatName", qstCatName);
    this.getQuestions(null, qstCatName.toUpperCase());
  }

  componentWillUnmount() {
    localStorage.removeItem("qstCatName");
    document.removeEventListener("emitted", (event) =>
      this.onUserAnswer(event)
    );
  }

  getParentQuestionResponse = (parentId) => {
    const ques = this.state.mapKeyed[parentId];
    // console.log("QUESTION : ",parentId," : ",ques)
    return ques;
  };
  getQuestions = async (qstCatNamePrevious, qstCatName, direction) => {
    const { simplifiedJourney } = this.state;
    this.props.showLoader(true);
    this.setButtonAttribute(true);
    this.setState({ disableButtons: true, loading: true });
    const { url, body } = getApiData("getQuestions");
    body.request.payload.lang = localStorage.getItem("LanguageSelected");
    body.request.payload.journeyBy = localStorage.getItem("journeyBy");
    if (simplifiedJourney == "y") {
      body.request.payload.simplifiedJourney = simplifiedJourney;
    } else {
      body.request.payload.simplifiedJourney = "n";
    }

    qstCatNamePrevious
      ? (body.request.payload.qstCatName = qstCatNamePrevious)
      : (body.request.payload.qstCatName = qstCatName);
    try {
      const response = await axios.post(url, body);
      // let respObj = {
      //   data: questionResponseData
      // }
      // let respObj = {
      //   data: insurerProposerQuesResponse
      // }
      // this.handleRsponse(respObj)
      this.handleRsponse(response);
    } catch (err) {
      console.log(err);
    } finally {
      window.scrollTo(0, 0);
      this.setButtonAttribute(false);
      this.props.showLoader(false);
      this.setState({ disableButtons: false, loading: false });
    }
  };

  handleRsponse = (response) => {
    this.setState({
      questions: [],
      allFieldsMandatoryError: false,
      loading: false,
      disableButtons: false,
    });
    const { isVideoPosv, simplifiedJourney } = this.state;
    console.log(response.data.response.payload);
    let debitDetails = JSON.stringify(
      response.data.response.payload.digitalDebit
    );
    const fiveYearLogicQuestIds = response?.data?.response?.payload?.fiveYearLogicQuestIds
    sessionStorage.setItem("fiveYearLogicQuestIds", fiveYearLogicQuestIds)
    if (response.data.response.payload.enableDigitalDebit === "Y") {
      console.log("inside dd", debitDetails);
      localStorage.setItem("digitalDebitData", debitDetails);
      localStorage.setItem(
        "category",
        response?.data?.response?.payload?.selfieStatus
      );
      if (isNewUI()) {
        this.setState({ showRedirectionScreen: true, redirectRoute: "dd" });
      } else {
        this.props.history.push("/direct-debit");
      }
      return;
    }
    if (response && !response.data.response.payload.customerResponse) {
      if (isNewUI() && !isPODPosv()) {
        if (
          response.data.response.payload.selfieStatus === "selfie" ||
          response.data.response.payload.selfieStatus === "selfie_live"
        ) {
          localStorage.setItem(
            "category",
            response.data.response.payload.selfieStatus
          );
          this.setState({
            showRedirectionScreen: true,
            redirectRoute: "selfie",
          });
        } else if (isVideoPosv === "Y") {
          this.setState({
            showRedirectionScreen: true,
            redirectRoute: "recording",
          });
        } else {
          this.setState({ showRedirectionScreen: true, redirectRoute: "otp" });
        }
        return;
      }
      if (localStorage.getItem("channelName").toLowerCase() === "x") {
        if (isVideoPosv === "Y") {
          this.props.history.push("/video-consent");
        } else {
          this.props.history.push("/declaration");
        }
      } else {
        if (isVideoPosv === "Y") {
          this.props.history.push("/video-consent");
        } else {
          this.props.history.push("/generate_otp");
        }
      }
      return;
    }
    const questions = JSON.parse(
      JSON.stringify(response.data.response.payload.customerResponse[0].qst)
    );
    const {
      qstCatNamePrevious,
      qstCatName,
      qstCatNameNext,
      wopRiderStatus: isWopRider,
      termPlan,
      heading,
      translatedHeading,
      hindiText,
      irpLogic,
      psmLogic,
      termPlanLogic,
    } = response.data.response.payload;

    if (simplifiedJourney == "y") {
      if (isVideoPosv === "Y") {
        this.props.startVideo()
        this.props.history.replace(`/video-verification`);
      } else {
        this.props.history.replace(`/customer_feedback`);
      }
    } else {
      if (isVideoPosv === "Y") {
        const { isVoiceOverDisable } = this.context;
        this.props.startVideo()
        this.props.history.replace(
          `/video-verification?page=${qstCatName.toLowerCase()}`
        );
        playVoiceOver("ques-aud", qstCatName);
        if (isVoiceOverDisable) {
          muteAudio("ques-aud");
        }
        // if (!isVoiceOverDisable) {
        //   playVoiceOver('ques-aud', qstCatName)
        // }
      } else {
        this.props.history.replace(
          `/customer_feedback?page=${qstCatName.toLowerCase()}`
        );
      }
    }

    console.log(" QST CAT NAME : ", qstCatName);
    if (qstCatName === "PROPOSAL") {
      handleProgress(35);
    }
    this.setState(
      {
        qstCatNamePrevious,
        qstCatName,
        qstCatNameNext,
        mapKeyed: mapKeys(questions, "qstId"),
        isWopRider,
        termPlan,
        termPlanLogic,
        heading,
        translatedHeading,
        irpLogic,
        psmLogic,
      },
      () => {
        makeBrAddedFalse();
        console.log(this.state.mapKeyed);
        let parents = [];
        let primaries = [];
        let secondaries = [];
        let secondaries2 = [];
        let tertiaries = [];

        questions.forEach((question) => {
          if (question.qstOptType == "radio2" && hindiText) {
            question.hindiText = hindiText;
          }
          if (question.qstOptType == "radio5") {
            let parentQuesResp = this.state.mapKeyed[question.qstPrtId];
            question.parentQuesResp = parentQuesResp;
          }
          if (question.qstType === "Parent") parents.push(question);
          if (question.qstType === "Primary") primaries.push(question);
          if (question.qstType === "Secondary") secondaries.push(question);
          if (question.qstType === "Secondary2") secondaries2.push(question);
          if (question.qstType === "Tertiary") tertiaries.push(question);
        });

        this.setState(
          { parents, primaries, secondaries, secondaries2, tertiaries },
          () => {
            handleQuestionsDisplay(
              this.state.parents,
              this.state.mapKeyed,
              "parent"
            );
            handleQuestionsDisplay(
              this.state.primaries,
              this.state.mapKeyed,
              "primary"
            );
            handleQuestionsDisplay(
              this.state.secondaries,
              this.state.mapKeyed,
              "secondary"
            );
            handleQuestionsDisplay(
              this.state.secondaries2,
              this.state.mapKeyed,
              "secondary2"
            );
            handleQuestionsDisplay(
              this.state.tertiaries,
              this.state.mapKeyed,
              "tertiary"
            );
            this.setState({ questions });
          }
        );
      }
    );
  };

  getChcBox2Rspns = (arr, val) => {
    if (arr && arr.length == 2) {
      if (val == "Yes") {
        return arr[0];
      } else {
        return arr[1];
      }
    } else {
      console.log("emptyArr");
      return null;
    }
  };

  onUserAnswer = (event) => {
    if (!event) {
      return;
    }
    const {
      qstId,
      value,
      termPlan,
      qstType,
      qstOptType,
      mandatory,
      qstOpt,
      checkbox5QstId,
      termPlanLogic,
    } = event.detail;
    let question = this.state.mapKeyed[qstId];
    if (qstOptType === "checkbox5") {
      question = this.state.mapKeyed[checkbox5QstId];
    }
    if (qstOptType == "checkbox2") {
      question.customerResponse = this.getChcBox2Rspns(qstOpt, value);
      if (
        (value !== "Yes" && mandatory == "M") ||
        question.customerResponse == null
      ) {
        delete question.customerResponse;
      }
    } else {
      if (question) {
        question.customerResponse = value;
      }
    }

    if (qstOptType === "checkbox3") {
      if (
        (value !== "Yes" && mandatory == "M") ||
        question.customerResponse == null
      ) {
        delete question.customerResponse;
      }
    }

    if (termPlan && termPlanLogic == "Y" && qstType === "Parent") {
      console.log(termPlan);
      console.log("termPlanLogic", termPlanLogic);
      this.state.primaries.forEach((q) => {
        if (question.qstId === q.qstPrtId) {
          if (value === qstOpt[0]) {
            delete q.customerResponse;
          } else {
            q.customerResponse = value;
          }
        }
      });
    }

    if (qstType === "Primary") {
      const parentId = question.qstPrtId
      if (parentId && parentId !== "null") {
        const parentQues = this.state.mapKeyed[parentId]
        if (question.customerResponse === question.qstOpt[0]) {
          parentQues.customerResponse = question.qstOpt[0]
        }
      }
    }

    handleQuestionsDisplay(
      this.state.parents,
      this.state.mapKeyed,
      "parent",
      termPlan,
      termPlanLogic
    );
    handleQuestionsDisplay(
      this.state.primaries,
      this.state.mapKeyed,
      "primary",
      termPlan,
      termPlanLogic
    );
    handleQuestionsDisplay(
      this.state.secondaries,
      this.state.mapKeyed,
      "secondary",
      termPlan,
      termPlanLogic
    );
    handleQuestionsDisplay(
      this.state.secondaries2,
      this.state.mapKeyed,
      "secondary2",
      termPlan,
      termPlanLogic
    );
    handleQuestionsDisplay(
      this.state.tertiaries,
      this.state.mapKeyed,
      "tertiary",
      termPlan,
      termPlanLogic
    );
    this.setState({ questions: values(this.state.mapKeyed) }, () => {
      // console.log(this.state.questions)
    });
  };

  getIncorrectResIndex = (question) => {
    let incQuesIds = ["P7i", "P4i"];
    if (question.qstId == "Q2" || question.qstId == "Q2_INS") {
      return question.qstOpt[0];
    } else if (incQuesIds.includes(question.qstId)) {
      console.log("P4 questions");
      return [question.qstOpt[0], question.qstOpt[2]];
    } else {
      return question.qstOpt[1];
    }
  };

  submitAnswers = async (image = "") => {
    console.log("first");
    let dates = [];
    let parentIds = [];
    let error = false;
    let blockJourney = false;
    const { simplifiedJourney, journeyBy, qstCatName } = this.state;
    const channelName = localStorage.getItem("channelName").toLowerCase()
    this.state.questions.forEach((question) => {
      if (
        question.qstOptType === "dateYearMask" &&
        question.customerResponse &&
        question.display === "block"
      ) {
        dates.push(question.customerResponse);
      }
      if (
        question.qstType === "Secondary" &&
        question.qstOptType === "text" &&
        question.display === "block" &&
        !question.customerResponse
      ) {
        parentIds.push(question.qstPrtId);
      }
      if (
        question.qstType === "Secondary2" &&
        (question.qstOptType === "checkbox" ||
          question.qstOptType === "checkbox5") &&
        question.display === "block"
      ) {
        parentIds.push(question.qstPrtId);
      }
    });

    if (parentIds.length) {
      for (let i = 0; i <= parentIds.length - 1; i++) {
        let childArray = [];
        this.state.questions.forEach((question) => {
          if (parentIds[i] === question.qstPrtId) {
            childArray.push(question);
          }
        });

        if (childArray.length === 1) {
          if (!childArray[0].customerResponse) {
            error = true;
            break;
          }
        }

        if (childArray.length > 1) {
          console.log("inside if");
          let answers = 0;
          for (let i = 0; i <= childArray.length - 1; i++) {
            console.log("inside for");
            if (
              childArray[i].qstOptType === "checkbox" &&
              childArray[i].customerResponse &&
              childArray[i].customerResponse === "Yes"
            ) {
              answers++;
            }
            if (
              (childArray[i].qstOptType !== "checkbox" ||
                childArray[i].qstOptType !== "checkbox5") &&
              childArray[i].qstOptType !== "text" &&
              childArray[i].customerResponse === "Yes"
            ) {
              answers++;
            }
          }
          if (!answers) {
            error = true;
            break;
          }
        }
      }
    }

    let isValid = true;
    if (dates.length > 0) {
      for (let i = 0; i <= dates.length - 1; i++) {
        isValid = isDateYearValid(dates[i]);
        if (isValid.error) {
          break;
        }
      }
    }

    if (isValid.error) {
      this.setState({ errorMsg: isValid.error });
      return;
    }

    const questions = JSON.parse(JSON.stringify(this.state.questions));
    const length = questions.length - 1;

    questions.forEach((question) => {
      if (question.qstFreezeResponse) {
        question.customerResponse = question.qstFreezeResponse;
        console.log("question with freezed option", question);
      }
    });
    for (let i = 0; i <= length; i++) {
      if (questions[i].qstOptType == "checkbox5") {
        console.log("first", questions[i]);
        console.log("prtid", questions[i].qstPrtId);
      }

      if (questions[i].qstOptType === "multipleSelection") {
        if (questions[i].display === "block" && (!questions[i].customerResponse || !questions[i].customerResponse.length > 0)) {
          error = true;
          break;
        }
      }

      if (
        questions[i].display === "block" &&
        !questions[i].customerResponse &&
        questions[i].mandatory &&
        questions[i].mandatory === "M"
      ) {
        error = true;
        break;
      }
    }

    let specialPrimaryIds = [];
    questions.forEach((question) => {
      if (question.display === "none" && question.qstType !== "text") {
        question.customerResponse = "null";
      }

      if (
        question.qstType === "Primary" &&
        question.customerResponse &&
        question.customerResponse === "Yes"
      ) {
        specialPrimaryIds.push(question.qstId);
      }

      delete question.display;
      delete question.addHrBelow;
      delete question.addBrAbove;
    });

    specialPrimaryIds.forEach((primaryId) => {
      questions.forEach((question) => {
        if (
          question.qstPrtId === primaryId &&
          question.qstOptType === "checkbox" &&
          (!question.customerResponse || question.customerResponse === "null")
        ) {
          question.customerResponse = "No";
        }
      });
    });

    if ((simplifiedJourney == "y" && journeyBy?.toLocaleLowerCase() != "i") || isPODPosv() || isSeniorCitizen()) {
      questions.forEach((question) => {
        if (
          question.qstOptType == "radio" ||
          question.qstOptType == "radio2" ||
          question.qstOptType == "radio4"
        ) {
          if (
            question.customerResponse &&
            question.customerResponse == this.getIncorrectResIndex(question)
          ) {
            console.log("Incorreect answer");
            blockJourney = true;
            return;
          } 
        } else if(question.qstType === "Summary" && question.customerResponse === question.qstOpt[1]) {
          blockJourney = true
          return
        }
      });
    } else {
      questions.forEach((question) => {
        if ((question.qstOptType == "radio" || question.qstOptType == "radio2") || ((question.qstOptType == "radio" || question.qstOptType == "radio2") && isPODPosv()) || ((question.qstOptType == "radio" || question.qstOptType == "radio2") && isSeniorCitizen())) {
          if (question.customerResponse) {
            let incQuesIds = ["P7i", "P4i"];
            if (incQuesIds.includes(question.qstId)) {
              let [incAns1, incAns2] = this.getIncorrectResIndex(question);
              if (incAns2.includes("/")) {
                incAns2 = incAns2.split("/")[0];
              }
              if (
                question.customerResponse == incAns1 ||
                question.customerResponse == incAns2
              ) {
                blockJourney = true;
              }
            }
            if (channelName?.toLowerCase() === 'by' && isNewUI() && question.qstId === 'Q2' && question.customerResponse === this.getIncorrectResIndex(question)) {
              blockJourney = true
            }
            return;
          }
        } else if(isPODPosv() && question.qstType === "Summary" && question.customerResponse === question.qstOpt[1]) {
          blockJourney = true
          return
        }
      });
    }

    if (error) {
      this.setState({ errorMsg: this.state.mandatoryError });
      if (isNewUI()) {
        const { handleMandatoryErrMsgDisplay } = this.props;
        if (handleMandatoryErrMsgDisplay) {
          handleMandatoryErrMsgDisplay(true);
        }
      }
      return;
    }
    this.saveCustomerResponses(questions, blockJourney, image);
  };

  saveCustomerResponses = async (questions, isblockJourney, image) => {
    const { vposv } = this.props;
    this.setState({ loading: true });
    const { url, body } = getApiData("saveCustomerResponse");
    const { qstCatName, simplifiedJourney, qstCatNameNext } = this.state;
    const channelName = localStorage.getItem("channelName").toLowerCase()
    body.request.payload.lang = localStorage.getItem("LanguageSelected");
    body.request.payload.isJournyStatusSuccess = isblockJourney ? "N" : "Y";
    body.request.payload.journeyBy = localStorage.getItem("journeyBy");
    if (simplifiedJourney == "y") {
      body.request.payload.simplifiedJourney = simplifiedJourney;
    } else {
      body.request.payload.simplifiedJourney = "n";
    }
    body.request.payload.qstCatName = qstCatName;
    // if (qstCatNameNext && qstCatNameNext.toLowerCase() === "proposal") {
    body.request.payload.qstCatNameNext = qstCatNameNext;
    // }
    if (qstCatName && qstCatName.toLowerCase() === "proposal") {
      // body.request.payload.qstCatNameNext = null;
      delete body.request.payload.custImg;
    }
    body.request.payload.qstCatName = qstCatName;
    body.request.payload.customerResponse.qstCatName = qstCatName;
    body.request.payload.customerResponse = [
      {
        qst: questions,
        qstCatName: qstCatName
      }
    ];
    if (qstCatName == "PRODUCT" || simplifiedJourney == "y" || channelName == 'by') {
      if (vposv) {
        body.request.payload.custImg = image;
      }
      body.request.payload.productTimestamp = Date.now();
    } else {
      if (vposv) {
        delete body.request.payload.custImg;
      }
      delete body.request.payload.productTimestamp;
    }

    if (vposv) {
      this.props.stopVideo()
    }

    try {
      this.setButtonAttribute(true);
      this.setState({
        errorMsg: "",
        disableButtons: true,
        disableSimplifiedSubmit: true,
      });
      this.props.showLoader(true);
      const response = await axios.post(url, body);
      window.scrollTo(0, 0);
      const { restrictOTP, restrictOTPMsg } = response.data.response.payload;
      localStorage.setItem("restrictOTP", restrictOTP);
      localStorage.setItem("restrictOTPMsg", restrictOTPMsg);
      if (isblockJourney) {
        this.props.history.push("/blocked_journey");
        return;
      } else {
        this.handleRsponse(response);
      }
    } catch (err) {
      this.setState({
        errorMsg: "There was some error. Please try again.",
        allFieldsMandatoryError: false,
        loading: false,
        disableButtons: false,
      });
    } finally {
      this.props.showLoader(false);
      this.setButtonAttribute(false);
      this.setState({ disableSimplifiedSubmit: false, loading: false });
    }
  };

  extractByteArrayAndType = (img) => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await compress(img);
        let { byteArray } = result;
        let { type, imgString } = getBase64TypeAndString(byteArray);
        resolve({ type, imgString });
      } catch (error) {
        console.log("image compressive error", error);
        reject(error);
      }
    });
  };

  gotToPage = async (direction) => {
    console.log(direction);
    stopAudio("ques-aud");
    const { qstCatName, simplifiedJourney } = this.state;
    const { vposv, captureImage } = this.props;
    const channelName = localStorage.getItem("channelName").toLowerCase()

    if (this.state.disableButtons) {
      return;
    }
    if (direction === "previous") {
      if (!this.state.qstCatNamePrevious) {
        return;
      }
      this.setState({ errorMsg: "" }, () => {
        this.getQuestions(this.state.qstCatNamePrevious, null, direction);
      });
    } else {
      if (vposv && (qstCatName == "PRODUCT" || simplifiedJourney == "y" || channelName == 'by')) {
        let image = captureImage();
        console.log("CAPTURE IMAGE...", image);
        const { imgString } = await this.extractByteArrayAndType(image);
        localStorage.setItem("custImg", image);
        this.setState({ userImg: imgString });
        this.submitAnswers(imgString);
        // this.setState({ custImg : image })
      } else {
        this.submitAnswers();
      }
    }
  };

  getPageName(tag) {
    console.log(tag);
    if (healthArray.includes(tag)) {
      return "Health";
    }
    if (tag === "MISCELLANEOUS") {
      return "Miscellaneous";
    }

    if (tag === "PRODUCT") {
      return "Product";
    }
    if (tag === "PSM") {
      return "PSM and IRP";
    }
    if (tag === "IRP") {
      return "Product Suitability and Investors Risk Profiling";
    }
    // heading changed for RPSales
    if (tag === "RPSALES") {
      return "Replacement Sale/Policy Splitting";
    }
    return tag.toLowerCase();
  }

  shouldComponentUpdate(state, newProps) {
    if (
      newProps.display !== this.state.display ||
      newProps !== this.state.questions
    ) {
      return true;
    }
    return false;
  }
  getSteps = () => {
    if (this.state.isNps == "Y" || this.state.journeyBy == "P") {
      return isNpsSteps;
    } else if (this.state.isVideoPosv == "Y") {
      return hybridPosvSteps;
    } else if (this.state.twoStep == "Y") {
      return QCSteps;
    } else {
      return photoVerificationSteps;
    }
  };

  getMainContainerClassName = () => {
    const { vposv } = this.props;
    const { qstCatName } = this.state
    if (isNewUI()) {
      if (vposv) {
        return `posv-2-ques customerFeedback-container vposv-que ${qstCatName.toLowerCase() === 'ybl_health' ? "health-ques" : ""}`;
      } else {
        return `posv-2-ques customerFeedback-container ${qstCatName.toLowerCase() === 'ybl_health' ? "health-ques" : ""}`;
      }
    } else {
      if (vposv) {
        return "customerFeedback-container vposv-que";
      } else {
        return "customerFeedback-container";
      }
    }
  };

  redirectToPage = (path) => {
    this.props.history.push(path);
  };

  validSubmitBtnForNewUI = () => {
    // disabled={disableSimplifiedSubmit || !faceDetected || (this.state.qstCatName.toLowerCase() === 'proposal' && !newCheckbox)}
    const {
      disableSimplifiedSubmit,
      qstCatName,
      newCheckbox,
      questions,
      channel,
    } = this.state;
    const { faceDetected, vposv } = this.props;
    let allQuestions = JSON.parse(JSON.stringify(this.state.questions));
    const proposalDeclarations = allQuestions.filter(
      (question) => question.qstType === "checkBoxDeclare"
    );
    const summaryQuestions = allQuestions.filter(q => q.qstType === "Summary")
    const questionOnScreen = questions.filter((que) => que.display === "block");
    let questionsAnswered = 0;
    let isValid = true;
    if (disableSimplifiedSubmit) {
      isValid = false;
    }
    if (vposv && !faceDetected) {
      isValid = false;
    }
    if (qstCatName.toLowerCase() === "proposal" && channel !== "x") {
      let totalChecboxes = proposalDeclarations.length;
      let totalchecked = 0;
      proposalDeclarations.forEach((p) => {
        if (p.isChecked) {
          totalchecked++;
        }
      });
      if (totalChecboxes !== totalchecked) {
        isValid = false;
      }
    }

    questions.forEach((ques) => {
      if (ques.customerResponse) {
        questionsAnswered++;
      }
      if (ques.qstOptType === "checkbox3" && (!ques.customerResponse || ques.customerResponse === "No")) {
        isValid = false;
      }
    });

    if (questionOnScreen.length !== questionsAnswered) {
      isValid = false;
    }
    // console.log('questionOnScreen',questionOnScreen.length, questionsAnswered)

    if (summaryQuestions?.length) {
      const answeredSummaryQuestions = summaryQuestions.filter(sq => sq.customerResponse )
      console.log('summaryQuestions', {answeredSummaryQuestions, summaryQuestions})
      if(summaryQuestions.length !== answeredSummaryQuestions.length) {
        isValid = false;
      }
    }

    return isValid;
  };

  getDeclarationCheckboxes = () => {
    let questions = JSON.parse(JSON.stringify(this.state.questions));
    const proposalDeclarations = questions.filter(
      (question) => question.qstOptType === "checkBoxDeclare"
    );
    return (
      proposalDeclarations.length > 0 &&
      proposalDeclarations.map((pd, index) => (
        <div className="new_checkbox" key={pd.type + index}>
          <label className="generateotp-checkobox">
            <input
              type="checkbox"
              id="newCheckbox"
              value={pd.customerResponse === "Yes" ? "Yes" : "No"}
              checked={pd.customerResponse === "Yes" ? true : false}
              onChange={(e) => this.handleProposalCheckboxes(e, pd.qstId)}
            />
            <span className="checkmark"></span>
          </label>
          <p className="check-sec">
            {/* {this.props.t(pd.declaration)} */}
            {pd.qstText}
          </p>
        </div>
      ))
    );
  };

  handleProposalCheckboxes = (e, qstId) => {
    let questions = JSON.parse(JSON.stringify(this.state.questions));
    let currentDeclaration = questions.filter((d) => d.qstId === qstId);
    currentDeclaration[0].customerResponse = e.target.checked ? "Yes" : null;
    this.setState({ questions });
  };

  getSummaryQuestions = () => {
    const questions = JSON.parse(JSON.stringify(this.state.questions));
    const summaryQuestions = questions.filter(
      (question) => question.qstType === "Summary"
    );
    return (
      summaryQuestions.length > 0 &&
      summaryQuestions.map((sq, index) => (
        <div className="summary-qst-cntnr" key={index}>
          <p className="summary-qst-txt">
            {sq.qstText}
          </p>
          <div className="summary-radio-cntnr">
            {
              sq.qstOpt.map((opt, optIndex) => (
                <p
                  className={`summary-radio-wrpr ${sq.customerResponse === opt ? 'activeRadio' : ''}`}
                  key={optIndex}
                  onClick={() => this.handleSummaryQuestion(opt, sq.qstId)}
                >
                  <span className="radio-crcle">
                    {sq.customerResponse === opt ? <span className="innr-crlc"></span> : null}
                  </span>
                  <span className="radio-lbl">
                    {opt}
                  </span>
                </p>
              ))
            }
          </div>
        </div>
      ))
    );
  };

  handleSummaryQuestion = (value, qstId) => {
    // const questions = JSON.parse(JSON.stringify(this.state.questions));
    // const summaryQuestion = questions.filter((d) => d.qstId === qstId);
    const summaryQuestion = this.state.mapKeyed[qstId];;
    summaryQuestion.customerResponse = value;
    this.setState({ questions: values(this.state.mapKeyed) });
  };

  disableSubmitForNonSimplified = () => {
    let parentIds = [];
    let error = false;
    let noOfChildArrays = 0
    let primaryAndParentRadioQuesAnswered = 0
    const { faceDetected, vposv } = this.props;
    let questionsDisplayedOnUI = 0
    if (vposv && !faceDetected) {
      return true
    }
    this.state.questions.forEach((q) => {
      if (q.display === "block") {
        questionsDisplayedOnUI++
      }
    })
    let radioTypes = ['radio', 'radio2', 'radio4', 'radio5', 'checkBoxDeclare']
    let primaryAndParentRadioQues = this.state.questions.filter((q) => q.display === "block" && !q.qstFreezeResponse && (radioTypes.includes(q.qstOptType)) && (q?.qstType?.toLowerCase() === "primary" || q?.qstType?.toLowerCase() === "parent"))

    let sspDropdownQues = this.state.questions.filter((q) => q.display === "block" && (q.qstOptType === 'dropdown5'))
    let sspNumQues = this.state.questions.filter((q) => q.display === "block" && (q.qstOptType === 'number5'))
    let sspTextQues = this.state.questions.filter((q) => q.display === "block" && (q.qstOptType === 'text5'))
    const multiSelectionQues = this.state.questions.filter((q) => q.display === "block" && (q.qstOptType === 'multipleSelection'))
    const calenderQues = this.state.questions.filter((q) => q.display === "block" && (q.qstOptType === 'calender2'))
    const isMultiSelectionNotAnswered = multiSelectionQues.some((mQ) => (!mQ.customerResponse || mQ?.customerResponse?.length < 1))
    const isCalenderQuesNotAnswered = calenderQues.some((cQ) => (!cQ.customerResponse || cQ?.customerResponse?.length < 1))

    console.log("MULTI :: ", { multiSelectionQues, calenderQues, isMultiSelectionNotAnswered, isCalenderQuesNotAnswered })

    if (multiSelectionQues?.length) {
      if (isMultiSelectionNotAnswered) return true
    }

    if (calenderQues?.length) {
      if (isCalenderQuesNotAnswered) return true
    }
    this.state.questions.forEach((question) => {
      if (
        question.qstType === "Secondary" &&
        question.qstOptType === "text" &&
        question.display === "block" &&
        !question.customerResponse
      ) {
        parentIds.push(question.qstPrtId);
      }
      if (
        question.qstType === "Secondary2" &&
        (question.qstOptType === "checkbox" ||
          question.qstOptType === "checkbox5") &&
        question.display === "block"
      ) {
        parentIds.push(question.qstPrtId);
      }
    });
    noOfChildArrays = parentIds.length
    if (parentIds.length) {
      for (let i = 0; i <= parentIds.length - 1; i++) {
        let childArray = [];
        this.state.questions.forEach((question) => {
          if (parentIds[i] === question.qstPrtId) {
            childArray.push(question);
          }
        });
        // console.log("PRIMARY IDS with childs : " + i, childArray)
        if (childArray.length === 1) {
          if (!childArray[0].customerResponse) {
            error = true;
            break;
          }
        }
        if (childArray.length > 1) {
          console.log("inside if");
          let answers = 0;
          for (let i = 0; i <= childArray.length - 1; i++) {
            console.log("inside for");
            if (
              childArray[i].qstOptType === "checkbox" &&
              childArray[i].customerResponse &&
              childArray[i].customerResponse === "Yes"
            ) {
              answers++;
            }
            if (
              (childArray[i].qstOptType !== "checkbox" ||
                childArray[i].qstOptType !== "checkbox5") &&
              childArray[i].qstOptType !== "text" &&
              childArray[i].customerResponse === "Yes"
            ) {
              answers++;
            }
          }
          if (!answers) {
            error = true;
            break;
          }
        }
      }
    }

    primaryAndParentRadioQues.forEach((ques) => {
      if (ques.customerResponse) {
        primaryAndParentRadioQuesAnswered++
      }
    })
    let dropdownResponses = 0
    let textResponses = 0
    let numberResponses = 0
    let sspSubQuesArr = [...sspDropdownQues, ...sspNumQues, ...sspTextQues]
    sspSubQuesArr.forEach((q) => {
      if (q.qstOptType === 'text5' && q.customerResponse) {
        textResponses++
      }
      if (q.qstOptType === 'number5' && q.customerResponse) {
        numberResponses++
      }
      if (q.qstOptType === 'dropdown5' && q.customerResponse) {
        dropdownResponses++
      }
    })

    const summaryQuestions = this.state.questions.filter(q => q.qstType === "Summary")

    if (summaryQuestions?.length) {
      const answeredSummaryQuestions = summaryQuestions.filter(sq => sq.customerResponse )
      if(summaryQuestions.length !== answeredSummaryQuestions.length) {
        return true
      }
    }
    let radioQuesResp = primaryAndParentRadioQues.length === primaryAndParentRadioQuesAnswered
    let sspFinalResp = sspDropdownQues.length === dropdownResponses && sspNumQues.length === numberResponses && sspTextQues.length === textResponses
    let finalResult = !radioQuesResp || !sspFinalResp || error
    // console.log("result : ", finalResult, radioQuesResp, error, primaryAndParentRadioQues.length, primaryAndParentRadioQuesAnswered)
    return finalResult
  }

  render() {
    const { redirectRoute, showRedirectionScreen } = this.state;
    const { vposv, faceDetected, loadingVerficationVideo } = this.props;
    const selectedJourneyLang = localStorage.getItem("LanguageSelected");
    if (showRedirectionScreen) {
      return (
        <VideoSubmission
          messageTxt={this.props.t("Response_Submitted")}
          redirectionMsg={redirectRoute}
          redirectToPage={this.redirectToPage}
        />
      );
    }
    if (this.state.loading && !this.state.questions.length) {
      if (!isNewUI()) {
        return (
          <div className="display_text">{this.props.t("Please wait")}</div>
        );
      }
    }

    const qstCatNameStyle = {
      fontSize: "20px",
      textAlign: "center",
      textTransform: "capitalize",
    };
    const {
      simplifiedJourney,
      disableSimplifiedSubmit,
      loading,
      newCheckbox,
      showPlanCodeDrawer,
      channel,
    } = this.state;
    return (
      <>
        {isNewUI() &&
          (loadingVerficationVideo ||
            loading ||
            (this.state.loading && !this.state.questions.length)) && (
            <DotsLoader
              msg={
                loadingVerficationVideo
                  ? this.props.t("Checking_camera_mircophone_access")
                  : this.props.t("Please wait")
              }
            />
          )}
        {isNewUI() && !vposv ? (
          <p className="posv2-ans-que-heading sposv-ques-eading">
            {this.props.t("read_details_and_provide_response")}
            <br />
            {this.state.errorMsg ? (
              <small className="required" style={{ textAlign: "center" }}>
                {this.props.t(`${this.state.errorMsg}`)}
              </small>
            ) : null}
          </p>
        ) : null}
        <div className={this.getMainContainerClassName()}>
          <audio className="aud-el-hide" id="ques-aud"></audio>
          {!vposv && <HeadStepper activeState={1} allSteps={this.getSteps()} />}
          {this.state.questions ? (
            <div className="cust_feedback--page">
              {this.state.qstCatName && simplifiedJourney != "y" && !isNewUI() ? (
                <div
                  style={qstCatNameStyle}
                  className={vposv ? "customerfeedback-heading" : ""}
                >
                  {this.getPageName(this.state.qstCatName) === "miscellaneous"
                    ? this.props.t(
                      `${this.getPageName(this.state.qstCatName)} Questions`
                    )
                    : this.props.t(
                      `${this.getPageName(
                        this.state.qstCatName
                      )} Related Questions`
                    )}
                </div>
              ) : null}
              {selectedJourneyLang === 'hin' && this.state.qstCatName.toLowerCase() === 'ybl_health' && <div className="ybl_health_disclaimer">
                <p>Disclaimer: Please take assistance to complete the journey</p>
              </div>}
              {this.state.translatedHeading ? (
                <div className="heading one">
                  {this.state.heading}
                  <br />
                  {this.state.translatedHeading}
                </div>
              ) : (
                <div className="heading one">{this.state.heading}</div>
              )}
              <>{this.getSummaryQuestions()}</>
              <form
                className={
                  isNewUI() &&
                    this.state.qstCatName.toLowerCase() === "proposal"
                    ? "customerFeedback-form proposal-ques"
                    : "customerFeedback-form"
                }
              >
                {isNewUI() &&
                  this.state.qstCatName.toLowerCase() === "proposal" && (
                    <div className="header-radio rowCustom">
                      <div className="colCustom">{this.props.t('Proposer details')}</div>
                      <div className="colCustom1 yes-no-cntnr">
                        <div>{this.props.t("No")}</div>
                        <div>{this.props.t("Yes")}</div>
                      </div>
                    </div>
                  )}
                {this.state.questions.map((question) => {
                  return (
                    <React.Fragment key={question.qstId}>
                      {!isNewUI() && question.addBrAbove &&
                        healthArray.includes(this.state.qstCatName) ? (
                        <div className="br_above"></div>
                      ) : null}
                      <Field
                        label="Label"
                        name={question.qstId}
                        type={question.qstOptType}
                        question={question}
                        component={createInput}
                        isWopRider={this.state.isWopRider}
                        termPlan={this.state.termPlan}
                        termPlanLogic={this.state.termPlanLogic}
                        primaryUserType={this.state.primaryUserType}
                        secondaryUserType={this.state.secondaryUserType}
                        customProps={(event) => this.onUserAnswer(event)}
                        getParentQuestionResponse={
                          this.getParentQuestionResponse
                        }
                        handleDrawerDisplay={() =>
                          this.setState({
                            showPlanCodeDrawer: !showPlanCodeDrawer,
                          })
                        }
                      />
                      {!isNewUI() && question.addHrBelow ? (
                        <div className="hr_below"></div>
                      ) : null}
                    </React.Fragment>
                  );
                })}
                {this.state.errorMsg && !isNewUI() ? (
                  <div
                    className="required"
                    style={{ textAlign: "center", marginTop: "0.1rem" }}
                  >
                    {/* {this.state.errorMsg} */}
                    {this.props.t(`${this.state.errorMsg}`)}
                  </div>
                ) : null}
              </form>

              {isNewUI() &&
                this.state.qstCatName.toLowerCase() === "proposal" &&
                channel !== "x" && (
                  <>
                    {this.getDeclarationCheckboxes()}
                    {/* <div className="new_checkbox" >
                      <label className="generateotp-checkobox">
                        <input
                          type="checkbox"
                          id="newCheckbox"
                          value={newCheckbox ? true : false}
                          checked={newCheckbox ? true : false}
                          onChange={() => this.setState({ newCheckbox: !newCheckbox })}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <p className="check-sec" >
                        {this.props.t(this.getDeclarationForCheckbox())}
                      </p>
                    </div> */}
                  </>
                )}

              {isNewUI() && vposv && !faceDetected && (
                <p className="new-ui-ques-err-msg">
                  *{this.props.t("Position_face_inside_circle")}
                </p>
              )}

              {this.state.questions.length && simplifiedJourney != "y" ? (
                <div className="button_div_unified" style={{
                  ...isNewUI() ? { gap: "" } : { gap: "16px" },
                }} >
                  {!isNewUI() && <Button
                    variant="extended"
                    // className="cust_fab"
                    onClick={() => this.gotToPage("previous")}
                    buttonType="primary"
                    size="default"
                  >
                    {this.props.t("preview")}
                  </Button>}

                  <Button
                    variant="extended"
                    // className={`${isNewUI() ? 'new-ui-next-btn submit_all_btn' : 'cust_fab'}`}
                    onClick={() => this.gotToPage("next")}
                    disabled={isNewUI() ? this.disableSubmitForNonSimplified() : false}
                    buttonType="primary"
                    {...isNewUI() ? { width: "264" } : { size:"default" }}
                    
                  >
                    {this.props.t("Next")}
                  </Button>
                </div>
              ) : null}

              {this.state.questions.length && simplifiedJourney == "y" ? (
                <div className="button_div_unified">
                  {/* <button
                    disabled={disableSimplifiedSubmit || !faceDetected || (this.state.qstCatName.toLowerCase() === 'proposal' && !newCheckbox)}
                    variant="extended"
                    className="cust_fab_submit_all submit_all_btn "
                    onClick={() => this.gotToPage("next")}
                  > */}
                  {isNewUI() ? (
                    vposv ? (
                      <Button
                        // disabled={disableSimplifiedSubmit || !faceDetected || (this.state.qstCatName.toLowerCase() === 'proposal' && !newCheckbox)}
                        disabled={!this.validSubmitBtnForNewUI()}
                        variant="extended"
                        // className="cust_fab_submit_all submit_all_btn "
                        onClick={() => this.gotToPage("next")}
                        buttonType="primary"
                        width="264"
                      >
                        {this.state.qstCatName.toLowerCase() === "proposal"
                          ? this.props.t("Submit")
                          : this.props.t("Next")}
                      </Button>
                    ) : (
                      <Button
                        // disabled={disableSimplifiedSubmit}
                        disabled={!this.validSubmitBtnForNewUI()}
                        variant="extended"
                        // className="cust_fab_submit_all submit_all_btn "
                        onClick={() => this.gotToPage("next")}
                        buttonType="primary"
                        width="264"
                      >
                        {this.state.qstCatName.toLowerCase() === "proposal"
                          ? this.props.t("Submit")
                          : this.props.t("Next")}
                      </Button>
                    )
                  ) : (
                    <Button
                      disabled={disableSimplifiedSubmit}
                      variant="extended"
                      // className="cust_fab_submit_all submit_all_btn "
                      onClick={() => this.gotToPage("next")}
                      buttonType="primary"
                      width="264"
                    >
                      {" "}
                      {this.props.t("Submit")}
                    </Button>
                  )}
                  {/* {this.props.t("submit")} */}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>

        {isNewUI() && showPlanCodeDrawer && (
          <PlanCodeDrawer
            handleState={() => this.setState({ showPlanCodeDrawer: false })}
          />
        )}

        {/* {isNewUI() && isBlockedJourney && <div className="actionsheet-ovrlay" >
          <div className="actionsheet-cntnr" >
            <div className="actionsheet-texts" >
              <p className="alrt-icn"><img src={alertIcon} alt="alrt-icn" /></p>
              <p className="actionsheet-incorrect-ans-msg">{this.props.t("incorrect_answers")}</p>
              <p className="actionsheet-review-ans-msg">{this.props.t("review_response_or_exit")}</p>
            </div>
            <div className="actionsheet-btns" >
              <button
                className="cust_fab_submit_all submit_all_btn "
                onClick={() => this.setState({ isBlockedJourney: false })}
              >
                {this.props.t("Review")}
              </button>
              <button
                className="cust_fab_submit_all submit_all_btn exit-btn"
                onClick={() => this.saveCustomerResponses(blockedJourneyResponses, isBlockedJourney, userImg)}
              >
                {this.props.t("Exit")}
              </button>

            </div>
          </div>
        </div>} */}
      </>
    );
  }
}

export default compose(
  withRouter,

  connect(null, { showLoader }),
  reduxForm({ form: "customerFeedbackForm" }),
  withTranslation()
)(CustomerFeedback);

CustomerFeedback.contextType = SpeakerContext;
